import * as React from 'react';

const IMAGE_FORMATS = ['jpg', 'jpeg', 'png', 'svg'];

export const useProductImages = (isUpdate) => {
  const [imageState, setImageState] = React.useState({
    imagem: null,
    imagemCard: null,
    imageLoaded: null,
    imageCardLoaded: null,
    loadingImage: false,
    updatedImage: false,
    updatedImageCard: false,
  });

  const isValidImageFormat = React.useCallback((file) => {
    if (!file) return false;
    const extension = file.name.split('.').pop().toLowerCase();
    return IMAGE_FORMATS.includes(extension);
  }, []);

  const getUpdatedField = React.useCallback((imageType) => {
    return imageType === 'imagem' ? 'updatedImage' : 'updatedImageCard';
  }, []);

  const handleImageUpload = React.useCallback((file, imageType) => {
    const updatedField = getUpdatedField(imageType);

    if (file === null) {
      setImageState((prev) => ({
        ...prev,
        [imageType]: null,
        [`${imageType}Loaded`]: null,
        [updatedField]: true,
      }));
      return;
    }

    const fileToRead = file?.target?.files?.[0] || file;
    if (!fileToRead) return;

    setImageState((prev) => ({
      ...prev,
      [imageType]: fileToRead,
      [updatedField]: true,
    }));

    try {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImageState((prev) => ({
          ...prev,
          [`${imageType}Loaded`]: reader.result,
        }));
      });
      reader.readAsDataURL(fileToRead);
    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
    }
  }, [getUpdatedField]);

  const handleImageCapaUpload = React.useCallback(
    (file) => handleImageUpload(file, 'imagem'),
    [handleImageUpload],
  );

  const handleImageCardUpload = React.useCallback(
    (file) => handleImageUpload(file, 'imagemCard'),
    [handleImageUpload],
  );

  const setLoadingImage = React.useCallback((loading) => {
    setImageState((prev) => ({ ...prev, loadingImage: loading }));
  }, []);

  return {
    imageState,
    setImageState,
    isValidImageFormat,
    handleImageCapaUpload,
    handleImageCardUpload,
    setLoadingImage,
  };
};
